var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTr5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2894,
    height: 543,
    viewBox: "0 0 2894 543",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1575_1901)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.312,
    cy: 271.312,
    r: 271.312,
    fill: "#00AA6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 859.156,
    cy: 271.312,
    r: 271.312,
    fill: "#00AA6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1447,
    cy: 271.312,
    r: 271.312,
    fill: "#00AA6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2034.84,
    cy: 271.312,
    r: 271.312,
    fill: "#00AA6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2622.69,
    cy: 271.312,
    r: 271.312,
    fill: "#00AA6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1575_1901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2894,
    height: 542.625,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr5);
export default __webpack_public_path__ + "static/media/tr-5.a04b70519557bac29b200da96585ebe4.svg";
export { ForwardRef as ReactComponent };